
























































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { setSlideBack } from '@/utils/index';
import yoda from '@/yoda';

interface IapItem {
    id: number;
    name: string;
    yDou: number;
    fen: number;
    dollar: string;
    couponFen: number;
    couponYDou: number;
}

@Component
export default class KsCoinIapListDialog extends Vue {
    @Prop({
        type: Boolean,
        default: false,
    })
    isRefreshing;
    @Prop({
        type: Array,
        default: () => [],
    })
    ksCoinIapList;
    @Prop({
        type: Number,
        default: 0,
    })
    ksCoin;
    @Prop({
        type: Number,
        default: 0,
    })
    userBalance;
    @Prop({
        type: String,
        default: 'paidContent',
    })
    productType;
    @Prop({
        type: Promise,
    })
    ext;

    isLoading = false;
    isCharging = false;
    activeItem: IapItem = {
        id: -1,
        name: '',
        yDou: -1,
        fen: -1,
        dollar: '',
        couponFen: -1,
        couponYDou: -1,
    };
    balance = 0;

    get coinNeeded() {
        return Math.max(this.ksCoin / 10 - this.userBalance, 0);
    }
    get recommendItem() {
        const length = this.ksCoinIapList.length;
        if (!length) {
            return {};
        }
        return (
            this.ksCoinIapList.find(item => item.yDou >= this.coinNeeded) ||
            this.ksCoinIapList[length - 1]
        );
    }
    mounted() {
        // Log: 快币充值收银台
        if (yoda.isInYoda) {
            window.ksLog?.sendCountTag('Lightks_KsCoinIapDialog');
        }
    }
    @Watch('ksCoinIapList', { immediate: true })
    initActiveItem(newValue, oldValue) {
        this.activeItem = this.recommendItem;
    }
    selectKsCoin(item) {
        this.activeItem = item as IapItem;
    }
    close() {
        // ios关闭页面 会有个向下滑动动画
        (this.$refs.mask as HTMLElement).style.background = 'transparent';
        this.$emit('close');
    }
    toCharge() {
        this.isCharging = true;
        setSlideBack(false);
        // fen iapItemName 和ksCoin
        this.$sendLog.pay({
            name: 'DETAIL_KSCOINCHARGE_START',
            ext: this.activeItem,
        });
        const params = {
            fen: this.activeItem.fen,
            ksCoin: this.activeItem.yDou,
            iapItemName: this.activeItem.name,
            disableSuccessAlert: true,
        };
        const successFn = ret => {
            this.$emit(
                'chargeSuccess',
                ret,
                this.userBalance + this.activeItem.yDou >= this.ksCoin,
            );
        };
        const failFn = err => {
            if (+err.result !== 0) {
                this.$sendLog.pay({
                    name: 'DETAIL_KSCOINCHARGE_FAIL',
                    ext: { ...this.activeItem, ...err },
                });
            }
            this.$emit('chargeFail', err);
        };
        const completeFn = () => {
            this.isCharging = false;
            setSlideBack(true);
            if (this.productType === 'eduqa') {
                window.removeEventListener('message', onMessageHandler, false);
            }
        };
        function onMessageHandler(res) {
            if (res.messageType === 'ksBridge.couponPay') {
                window.removeEventListener('message', onMessageHandler, false);
                switch (res.data.messageStatus) {
                    case 'success':
                        successFn(res.data.ret);
                        break;
                    case 'fail':
                        failFn(res.data.ret);
                        break;
                    case 'complete':
                        completeFn();
                        break;
                }
            }
        }
        if (this.productType === 'eduqa') {
            window.addEventListener('message', onMessageHandler, false);
            window.parent.postMessage(
                {
                    messageType: 'ksBridge.couponPay',
                    params,
                },
                '*',
            );
        } else {
            yoda('kwai', 'couponPay', params, res => {
                completeFn();
                if (res.result === 1) {
                    successFn(res);
                } else {
                    failFn(res);
                }
            });
        }
    }
}
